"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const one_1 = require("remax/one");
const one_2 = require("../one");
const classnames_1 = __importDefault(require("classnames"));
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('cascade');
let flag = false;
const Cascade = (props) => {
    const { name, value = [], options = [], height = '80vh', className = '', prompt, onChange, onComplete, } = props;
    const [showedOptions, setShowedOptions] = react_1.useState(options);
    const [sign, setSign] = react_1.useState(false);
    const [scrollTop, setScrollTop] = react_1.useState(0);
    // useEffect(() => {
    //   if (options && options.length > 0) {
    //     setShowedOptions(options);
    //   }
    // }, [options]) // 无法使用此 useEffect，使用后会报错。
    react_1.useEffect(() => {
        if (sign && value.length > 0 && flag) {
            setSign(false);
            flag = false;
            const item = value[value.length - 1];
            onComplete === null || onComplete === void 0 ? void 0 : onComplete(value, {
                key: item.key,
                value: item.value,
            });
        }
    }, [value, sign]);
    const handleClick = (i) => __awaiter(void 0, void 0, void 0, function* () {
        let nextValue = [];
        const nextOption = {
            key: i.key,
            value: i.value,
            parentKey: i.parentKey,
        };
        if (value.length > 0 && value[value.length - 1].parentKey === i.parentKey) {
            nextValue = [...value.slice(0, value.length - 1), nextOption];
        }
        else {
            nextValue = [...value, nextOption];
        }
        onChange(nextValue, nextOption);
        setScrollTop(top => {
            return top === 0 ? 1 : 0;
        });
        if (Array.isArray(i.children) && i.children.length > 0) {
            setShowedOptions(i.children);
        }
        else {
            flag = true;
            setSign(true);
        }
    });
    const getMatchLevelOptions = (key, data) => {
        let r = null;
        for (let i = 0; i < data.length; i++) {
            const item = data[i];
            if (key === item.key) {
                r = data;
            }
            else if (item.children) {
                r = getMatchLevelOptions(key, item.children);
            }
            if (r) {
                return r;
            }
        }
        return r;
    };
    const handleReChoose = (item, index) => {
        onChange(value.slice(0, index + 1));
        setShowedOptions(getMatchLevelOptions(item.key, options));
        setScrollTop(top => {
            return top === 0 ? 1 : 0;
        });
    };
    const h = value.length > 1 ? 90 * value.length + 40 - 30 : 130;
    return (react_1.default.createElement(one_1.View, { className: classnames_1.default({
            [prefixCls]: true,
            [className]: true,
        }), style: {
            height,
        } },
        react_1.default.createElement(one_1.View, { className: `${prefixCls}-selected` }, value.map((item, index) => (react_1.default.createElement(one_1.View, { key: item.key, className: `${prefixCls}-step`, onTap: () => {
                handleReChoose(item, index);
            } },
            react_1.default.createElement(one_1.View, { className: `${prefixCls}-step-line` },
                index === value.length - 1 ? null : (react_1.default.createElement(one_1.View, { className: `${prefixCls}-step-line-active` })),
                react_1.default.createElement(one_1.Text, { className: `${prefixCls}-step-dot` })),
            react_1.default.createElement(one_1.View, { className: `${prefixCls}-step-container` },
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-step-content` },
                    react_1.default.createElement(one_1.View, { className: `${prefixCls}-step-left` }, item.value),
                    react_1.default.createElement(one_1.View, { className: `${prefixCls}-step-right` },
                        react_1.default.createElement(one_1.View, { className: `${prefixCls}-step-right-text` }, prompt === null || prompt === void 0 ? void 0 : prompt(index)),
                        react_1.default.createElement(one_1.View, { className: `${prefixCls}-step-right-arrow` },
                            react_1.default.createElement(icon_1.default, { type: "right", size: "24px", color: "#999" }))))))))),
        react_1.default.createElement(one_1.View, null,
            react_1.default.createElement(one_2.ScrollView, { scrollY: true, className: `${prefixCls}-showed`, scrollTop: scrollTop, style: {
                    height: `calc(${height} - ${h + 80}px)`,
                } },
                react_1.default.createElement(one_1.View, { className: `${prefixCls}-showed-title` }, `选择${name}`),
                showedOptions.map(i => (react_1.default.createElement(one_1.View, { key: i.key, className: `${prefixCls}-showed-category`, onTap: () => {
                        handleClick(i);
                    } }, i.value)))))));
};
exports.default = Cascade;
